import type { CategoryFormState } from '@openx/types/targeting/category';
import {
  DomainTargeting,
  type DomainTargetingType,
  type UrlTargeting,
  UrlTargetingType,
} from '@openx/types/targeting/domains';
import { Intersect } from '@openx/types/targeting/targetingValuesTypes';
import isEqual from 'lodash/isEqual';

type Props = {
  blockedCategories: string[];
  blockedDomains: string[];
  accountDomainTargetingOption?: DomainTargetingType;
  initState: CategoryFormState | UrlTargeting;
};

export const checkIsInheritingFromAccount = ({
  blockedCategories,
  blockedDomains,
  accountDomainTargetingOption = DomainTargeting.ALL_VARIATIONS,
  initState,
}: Props) => {
  const isCategoryType = 'val' in initState;
  if (isCategoryType) {
    if (initState.val.size === 0 && new Set(blockedCategories).size === 0) return true;

    return isEqual(initState.val, new Set(blockedCategories)) && initState.op === Intersect.NOT_INTERSECTS;
  }

  if (!blockedDomains.length && !initState.urls?.length) {
    return true;
  }

  // Compare domains ignoring order by sorting both arrays
  const sortedBlockedDomains = [...blockedDomains].sort();
  const sortedInitStateUrls = [...(initState.urls || [])].sort();

  return (
    isEqual(sortedInitStateUrls, sortedBlockedDomains) &&
    initState.type === UrlTargetingType.blacklist &&
    initState.domain_targeting_option === accountDomainTargetingOption
  );
};
